/**
 * Extract rule patterns from the first column of a CSV file (base64-encoded).
 * @param {string} base64Content
 * @returns {string[]}
 */
export function parsePatternsFromCsvBase64(base64Content) {
  if (!base64Content) {
    return [];
  }

  try {
    const text = atob(base64Content);
    const lines = text
      .split(/\r?\n/)
      .map(line => line.trim())
      .filter(Boolean);

    if (!lines.length) {
      return [];
    }

    const firstLine = lines[0].toLowerCase();
    const hasHeader = firstLine.includes('pattern') || firstLine.startsWith('id,');
    const dataLines = hasHeader ? lines.slice(1) : lines;

    return [...new Set(dataLines.map(line => line.split(',')[0].trim()).filter(Boolean))];
  } catch (error) {
    console.error('[CSV Pattern Parser] Failed to parse CSV:', error);
    return [];
  }
}
